module.exports = __webpack_public_path__ + "static/media/shield.1613a38d.svg";